import { useGetAllLabWorksQuery } from '@pm/graphql';
import { Text } from '@pm/ui';
import { useTranslation } from 'react-i18next';
import { InView } from 'react-intersection-observer';
import { LoadingPage } from '../LoadingPage';
import { LabError } from './LabError';
import { PastLabs } from './PastLabs';

export const NewLabHistoryPage = ({ supportLink }: { supportLink: string }) => {
  const { data, error, loading, fetchMore } = useGetAllLabWorksQuery({
    fetchPolicy: 'network-only',
    variables: {
      first: 50,
    },
  });
  const { t } = useTranslation('labs');

  const onFetchMore = () => {
    if (!data?.labWorks?.pageInfo?.hasNextPage) return;

    fetchMore({
      variables: {
        after: data.labWorks.pageInfo.endCursor,
      },
    });
  };

  if (loading) {
    return <LoadingPage />;
  }

  if (error) {
    return <LabError error={error} supportLink={supportLink} />;
  }

  const allLabWorks = data?.labWorks?.edges || [];
  const hasNextPage = data?.labWorks?.pageInfo?.hasNextPage;

  return (
    <div className="space-y-xl pb-xxl">
      <Text size="headingM" as="h1">
        {t('PastLabs')}
      </Text>

      <PastLabs labWorks={allLabWorks} />

      {hasNextPage && (
        <InView
          as="div"
          className="text-brand-primary-500 flex justify-center pt-4"
          onChange={(inView) => inView && onFetchMore()}
        />
      )}
    </div>
  );
};
